import { useContext } from 'react'
import { useAppSelector } from 'hooks/reduxHooks'
import useLoyaltyBurnExperiment from 'loyalty/hooks/useLoyaltyBurnExperiment'
import OfferPageStateContext from 'contexts/OfferPage/offerPageStateContext'
import { selectLoggedIn } from 'selectors/accountSelectors'
import getIsLoyaltyEnabled from 'loyalty/selectors/getIsLoyaltyEnabled'
import getHasLoyaltyAccount from 'loyalty/selectors/getHasLoyaltyAccount'
import { MINIMUM_POINTS_TO_APPLY } from 'loyalty/constants/loyaltyBurn'

export default function useCalendarBurnToggleVisible(): boolean {
  const { charterBundleEnabled } = useContext(OfferPageStateContext)
  const { isAnyVariant: isBurnEnabled } = useLoyaltyBurnExperiment()
  const isLoggedIn = useAppSelector(selectLoggedIn)
  const isLoyaltyEnabled = useAppSelector(getIsLoyaltyEnabled)
  const hasLoyaltyAccount = useAppSelector(getHasLoyaltyAccount)
  const userPoints = useAppSelector(state => state.loyalty.account.data?.points ?? 0)

  if (charterBundleEnabled) return false
  if (!isBurnEnabled) return false
  if (!isLoyaltyEnabled) return false
  if (!isLoggedIn) return true
  if (!hasLoyaltyAccount) return false
  return userPoints >= MINIMUM_POINTS_TO_APPLY
}
